import React from "react";
import * as S from "./carManagementModal.style";
import Modal from "..";
import { Button } from "../../../atoms/Buttons";

type CarManagementModalType = {
  onModalCloseHandler: () => void;
};

const CarManagementModal = ({
  onModalCloseHandler,
}: CarManagementModalType) => {
  return (
    <Modal title="차량정보 변경 완료" titlePosition="center" size="md">
      <S.CarManagementModalLayout>
        <div className="textBox">차량 정보변경이 완료되었습니다.</div>
        <Button
          type="button"
          size="full"
          color="primary"
          label="닫기"
          onClick={onModalCloseHandler}
        />
      </S.CarManagementModalLayout>
    </Modal>
  );
};

export default CarManagementModal;
